import { render } from "./image-text-overlay.vue?vue&type=template&id=61b19b28"
import script from "./image-text-overlay.vue?vue&type=script&lang=js"
export * from "./image-text-overlay.vue?vue&type=script&lang=js"

import "./image-text-overlay.vue?vue&type=style&index=0&id=61b19b28&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__